import { ArbetsorderKartutsnittDTO } from "~app/common/models/planera/v2/ArbetsorderKartutsnittDTO";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { ArbetsorderKartutsnittBaseCommand } from "./ArbetsorderKartutsnittBaseCommand";

export class AddArbetsorderKartutsnittCommand extends ArbetsorderKartutsnittBaseCommand {
    kartutsnitt: ArbetsorderKartutsnittDTO;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "AddArbetsorderKartutsnittCommand";

    constructor(arbetsorderId: number, kartutsnitt: ArbetsorderKartutsnittDTO) {
        super(AddArbetsorderKartutsnittCommand.$type, CommandType.Insert);
        this.arbetsorderId = arbetsorderId;
        this.kartutsnitt = kartutsnitt;
        this.kartutsnittId = kartutsnitt.guid;
    }
}
